<template>
  <el-drawer
    title="Detalle de Pago Proveedores"
    :visible.sync="showDrawer"
    :before-close="beforeClose"
    size="75%"
    :modal="false"
  >
    <el-card class="card">
      <div>
        <el-row>
          <el-col :span="3" :offset="1">
            <h2>Cliente:</h2>
          </el-col>
          <el-col :span="10">
            <h2>
              <strong
                ><b>{{ CurrentClienData.clientName }}</b></strong
              >
            </h2>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3" :offset="1">
            <h2>Total:</h2>
          </el-col>
          <el-col :span="10">
            <h2>
              <strong
                ><b>{{ total }}</b></strong
              >
            </h2>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-row
          class="flex-container-balance"
          style="padding-bottom: 0px; margin-bottom: 0px"
        >
          <el-button
            type="primary"
            icon="el-icon-download"
            @click="exportReport"
            >Exportar</el-button
          >
          <el-col>
            <rabbey-toolbox
              filter-placeholder="Buscar por nombre"
              filterables
              @filter-search="search = $event"
            />
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <rabbey-table3
            :height="600"
            style="overflow: auto"
            ref="customerTable"
            :columns="PagoProveedoresDetailledColumns"
            v-loading="loading_Balance_Data"
            :search="search"
            :border="true"
            :stripe="true"
            :data="FilteredData"
            :show-summary="true"
            :summary-method="getSummaries"
          />
        </el-row>
      </div>
    </el-card>
  </el-drawer>
</template>

<script>
import { Decimal } from "decimal.js";
import { PagoProveedoresDetailledColumns } from "@/views/apps/ncfmovil/columnsTables/PagoProveedoresColumns.js";
import { formatMonto } from "@/utils";
import { exportExcel } from "@/helpers/exportExcel";
export default {
  name: "ClientBalanceReportDetailed",
  props: {
    showDrawer: {
      type: Boolean,
      default: false
    },
    CurrentClienData: {
      type: Object,
      default: () => {}
    }
    /*
      ClienId: {
        type: Number,
        default: 0
      },
      SuplierId: {
        type: Number,
        default: 0
      }
      */
  },
  data() {
    return {
      PagoProveedoresDetailledColumns,
      ClientePagoProveedoresDataDetail: [],
      loading_Balance_Data: false,
      search: "",
      ClientSelected: "",
      CardHolderFiltered: [],
      FilteredData: [],
      DiffSelected: "All",
      total: 0.0,
      DiffOptions: [
        {
          value: "All",
          label: "Todos con o sin diferencias de Balances"
        },
        {
          value: "Diff",
          label: "Tiene diferencias de Balances"
        },
        {
          value: "NoTDiff",
          label: "No Tiene diferencias de Balances"
        }
      ]
    };
  },
  mounted() {
    this.GetBalanceReportDetailData(
      this.CurrentClienData.clientid,
      this.CurrentClienData.supplierId
    );
  },
  computed: {
    dataClients() {
      let ClientsData = this.ClientePagoProveedoresDataDetail.map(
        (BalanceDetail) => {
          return {
            cardHolderId: BalanceDetail.cardHolderId,
            cardHolderName: BalanceDetail.cardHolderName
          };
        }
      );
      return ClientsData;
    }
  },
  methods: {
    async exportReport() {
      await exportExcel(
        PagoProveedoresDetailledColumns.map((column) => {
          return column.label;
        }),

        this.ClientePagoProveedoresDataDetail.map((data) => {
          return [
            data.Id,
            data.fechaHora,
            data.Descripcion,
            data.Monto < 0 ? data.Monto * -1 : data.Monto,
            data.Proveedor,
            data.RegistroPago
          ];
        }),
        "Pago proveedores"
      );
    },
    async GetBalanceReportDetailData(ClienId = null, SuplierId = null) {
      //("GetBalanceReportDetailData: ","C ", ClienId, "S ", SuplierId )
      this.loading_Balance_Data = true;
      await this.$http
        .get(
          `/api/tennos/GetClientPaymentReportDetail?EmpresaId=${SuplierId}&ClientId=${ClienId}`
        )
        .then((resp) => {
          this.FilteredData = this.ClientePagoProveedoresDataDetail = resp.data;
          let total = new Decimal(0.0);
          resp.data.forEach((x) => {
            //console.log(total.toNumber())
            total = total.plus(x.Monto);
            //total = parseFloat(total + "") + parseFloat(x.Monto + "");
            //total = total.toFixed(2);
          });
          total = total.toNumber();
          if (total < 0) {
            total = total * -1;
          }
          this.total = total;
          /*
            this.ClientePagoProveedoresDataDetail.forEach((cardHolder) => {
              cardHolder.OpenDetail = this.OpenDetail;
            });
            */
          /*
            console.log(
              "ClientePagoProveedoresDataDetail: ",
              this.ClientePagoProveedoresDataDetail
            );
            */
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading_Balance_Data = false;
        });
      //console.log("Master Report: ", await this.SupplierBalanceDataMaster)
    },
    beforeClose() {
      this.$emit("OncloseDetail");
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index < 1) {
          return;
        }
        if (index === 1) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    onCardHolderChanging(CardHolderId) {
      //console.log("CardHolderId: ", CardHolderId)
      //console.log("ClientePagoProveedoresDataDetail: ", this.ClientePagoProveedoresDataDetail)

      if (!CardHolderId) {
        this.FilteredData = this.CardHolderFiltered =
          this.ClientePagoProveedoresDataDetail;
      } else {
        this.FilteredData = this.CardHolderFiltered =
          this.ClientePagoProveedoresDataDetail.filter(
            (balanceData) => balanceData.cardHolderId === CardHolderId
          );
        //console.log("CardHolderFiltered: ", this.CardHolderFiltered)
      }
    },
    async onDiffChanging(concept) {
      switch (concept) {
        case "All": {
          this.FilteredData = this.ClientePagoProveedoresDataDetail;
          break;
        }
        case "Diff": {
          this.FilteredData = this.ClientePagoProveedoresDataDetail.filter(
            (balanceData) => balanceData.balanceDiff !== 0
          );
          break;
        }
        case "NoTDiff": {
          this.FilteredData = this.ClientePagoProveedoresDataDetail.filter(
            (balanceData) => balanceData.balanceDiff === 0
          );
          break;
        }
        default: {
          break;
        }
      }
    }
  }
};
</script>

<style lang="css" scoped>
.flex-container-balance {
  display: flex-end;
  /*height: 200px;*/
  align-items: center;
}

.supliers_select {
  min-width: 60%;
}

.card {
  margin: 10;
}
</style>
